import React, { useState, useRef, useContext } from 'react'
import { Row, Col, Table, Typography, Button, Pagination, Icon, Input, notification } from 'antd'
import { withRouter } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import moment from 'moment'
import { GET_CHECKINS, CHECKINS_CONNECTIONS, REVERSE_PAYMENT } from '../../checkins/graphql/Queries'
import Meta from '../../../components/Meta'
import client from '../../../apollo'
import { AppContext } from '../../../AppContext'
import ReverseModal from '../../checkins/components/ReverseModal'
import ReverseDetailsModal from '../../checkins/components/ReverseDetailsModal'
import titleCase from '../../../components/titleCase'
import '../restaurants.css'

const { Title } = Typography

function RestaurantCheckIn(props) {
  const { state } = useContext(AppContext)
  const [isSubmit, setSubmit] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showReverseDetailsModal, setShowReverseDetailsModal] = useState(false)
  const [editableData, setEditableData] = useState("")
  const { match: { params: { restaurantId } } } = props
  const [tableLoading, setTableLoading] = useState(false)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [orderByFilter, setOrderByFilter] = useState("checkIn_DESC")
  const [filters, setFilters] = useState({})
  let { data: checkInData, error: checkInError, loading: checkInLoad, networkStatus, fetchMore } = useQuery(GET_CHECKINS, { variables: { first: 10, filters: { ...filters, restaurant: { id: restaurantId } }, orderByFilter }, fetchPolicy: 'network-only' })
  let { data: checkInDataCount, error: checkInDataCountError } = useQuery(CHECKINS_CONNECTIONS, { variables: { filters: { ...filters, restaurant: { id: restaurantId } }, orderByFilter }, fetchPolicy: "network-only" })
  const totalCount = !checkInDataCountError ? (checkInDataCount && checkInDataCount.checkInsConnection) ? checkInDataCount.checkInsConnection.aggregate.count : 1 : 1
  const saveFormRef = useRef()
  const canReverse = state && state.currentUser && state.currentUser.role && state.currentUser.role === 'ADMIN'

  function getColumnSearchProps(dataIndex) {

    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            ref={input => input && input.focus()}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: filtered => (
        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      // sorter: (a, b) => a.age - b.age
    }
  }

  function handleChange(pagination, filters, sorter) {
    if (sorter && sorter.field && sorter.order) {
      setCurrentPageNumber(1)
      if (sorter.order === "descend") {
        setOrderByFilter(`${sorter.field}_DESC`)
      } else {
        setOrderByFilter(`${sorter.field}_ASC`)
      }
    }
  }

  function handleSearch(selectedKeys, confirm, dataIndex) {
    setCurrentPageNumber(1)
    confirm()
    let tempFilters = {}
    if (dataIndex === 'customerName') {
      tempFilters['user'] = {
        "OR":
          [{ "lastName_contains": selectedKeys[0].toLowerCase() },
          { "lastName_contains": selectedKeys[0].toUpperCase() },
          { "lastName_contains": titleCase(selectedKeys[0]) },
          { "lastName_contains": selectedKeys[0] },
          { "firstName_contains": selectedKeys[0].toLowerCase() },
          { "firstName_contains": selectedKeys[0].toUpperCase() },
          { "firstName_contains": titleCase(selectedKeys[0]) },
          { "firstName_contains": selectedKeys[0] },
          ]
      }
      // tempFilters['user']["lastName_contains"] = selectedKeys[0]
    } else if (dataIndex === 'transactionId') {
      tempFilters['transaction'] = {
        "OR":
          [
            { "id_contains": selectedKeys[0] },
          ]
      }
    }
    setFilters({ ...filters, ...tempFilters })
  }

  function handleReset(clearFilters, dataIndex) {
    clearFilters();
    let tempFilters = {}
    if (dataIndex === 'customerName') {
      tempFilters['user'] = {
        "OR":
          [{ "lastName_contains": "" },
          { "firstName_contains": "" }
          ]
      }
      // tempFilters['user']["lastName_contains"] = selectedKeys[0]
    } else if (dataIndex === 'transactionId') {
      tempFilters['transaction'] = {
        "OR":
          [{ "id_contains": "" },
          ]
      }
    }
    setFilters({ ...filters, ...tempFilters })
  }

  function handleCancel() {
    saveFormRef.current.props.form.resetFields()
    setSubmit(false)
    setEditableData("")
    setShowModal(false)
    setShowReverseDetailsModal(false)
  }

  function handleCreate() {
    const form = saveFormRef.current.props.form
    form.validateFields(async (err, values) => {
      if (err) {
        return
      }
      // setSubmit(true)
      const { topUp = 0, lastOverDueAmount = 0, points = 0, actualAmount, transactionId, note } = values
      const totalAmount = points + lastOverDueAmount + topUp
      if (actualAmount < totalAmount) {
        openNotification('error', 'Total amount can not be greater then actual amount!')
        return
      } else if (totalAmount === 0) {
        openNotification('error', 'Total amount cannot be zero or empty!')
        return
      }
      try {
        await client.mutate({
          mutation: REVERSE_PAYMENT,
          variables: {
            transactionID: transactionId,
            points: points,
            lastOverDueAmount: lastOverDueAmount,
            topUp: topUp,
            notes: note,
            amount: actualAmount
          },
          refetchQueries: [{
            query: GET_CHECKINS,
            variables: { filters, orderByFilter },
            fetchPolicy: "network-only"
          }]
        }).then(res => {
          openNotification('success', 'Payment successfully reversed!')
          setSubmit(false)
          setShowModal(false)
          setEditableData("")
          form.resetFields()
        })
      } catch (e) {
        console.log(e)
        setSubmit(false)
        openNotification('error', 'Something Went Wrong!')
      }
    })
  }



  function openNotification(type, message) {
    notification[type]({
      message,
      duration: 3
    })
  }

  function handleReverse(record) {
    setEditableData(record)
    setShowModal(true)
  }

  function showReverseDetail(data) {
    setEditableData(data)
    setShowReverseDetailsModal(true)
  }

  const column = [
    {
      title: 'Transaction ID',
      dataIndex: 'transactionID',
      width: '10%',
      render: (transactionID) => transactionID ? transactionID : '-',
      ...getColumnSearchProps('transactionId')
    },
    {
      title: 'Customer',
      dataIndex: 'customerName',
      width: '20%',
      render: (text) => text ? text : '-',
      ...getColumnSearchProps('customerName')
    },
    {
      title: 'Amount (₹)',
      dataIndex: 'amount',
      width: '17%',
      render: (amount, record, index) => amount ?
        <div>
          <span>{record.reverseTransactionData ? amount - Math.abs(record.reverseTransactionData.amount) : amount}</span>
          <span style={{ float: 'right', cursor: 'pointer' }}>
            {
              record.reverseTransactionData ?
                <Icon type="info-circle" theme="twoTone" onClick={() => showReverseDetail(record)} />
                :
                canReverse ? <Button type="primary" size='small' onClick={() => handleReverse(record)}>Reverse</Button> : null
            }</span>
        </div>
        :
        '-',
    },
    {
      title: 'In Time',
      dataIndex: 'checkIn',
      width: '20%',
      render: (time) => time ? moment(time).format('DD/MM/YYYY, hh:mm A') : '-',
      sorter: (a, b) => a.age - b.age
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      width: '13%',
      render: (duration) => `${parseInt(duration / 60) ? `${parseInt(duration / 60)} hours ` : ''}${Math.round(duration % 60)} minutes`
    },
    {
      title: 'Commission (₹)',
      dataIndex: 'commission',
      width: '10%',
      render: (commission) => commission ? Math.round(commission) : '-'
    },
    // {
    //   title: 'Discount (₹)',
    //   dataIndex: 'discount',
    //   width: '10%',
    //   render: (discount) => discount ? Math.round(discount) : '-'
    // },
    {
      title: 'Paid At',
      dataIndex: 'createdAt',
      width: '20%',
      render: (createdAt) => createdAt ? moment(createdAt).format('DD/MM/YYYY, hh:mm A') : '-',
      sorter: (a, b) => a.age - b.age
    }
  ]
  const columns = column.map((col) => {
    return {
      ...col,
      onCell: record => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    }
  })

  let postTableData = []
  if (!checkInError && checkInData && checkInData.checkIns) {
    postTableData = checkInData.checkIns.map((checkIn, key) => (
      {
        key: key.toString(),
        amount: checkIn.transaction && checkIn.transaction.amount ? checkIn.transaction.amount : null,
        transactionID: checkIn.transaction && checkIn.transaction.id ? checkIn.transaction.id : null,
        customerId: checkIn.user && checkIn.user.id ? checkIn.user.id : null,
        customerName: `${checkIn.user && checkIn.user.firstName ? checkIn.user.firstName : '-'} ${checkIn.user && checkIn.user.lastName ? checkIn.user.lastName : '-'}`,
        createdAt: checkIn.transaction && checkIn.transaction.createdAt ? checkIn.transaction.createdAt : null,
        commission: checkIn.transaction ? Math.round(checkIn.transaction.commissionAmount) : null,
        // discount: checkIn.transaction ? Math.round(checkIn.transaction.discountAmount) : null,
        duration: checkIn.duration ? checkIn.duration : null,
        checkIn: checkIn.checkIn ? checkIn.checkIn : null,
        transactionId: checkIn.transaction && checkIn.transaction.id ? checkIn.transaction.id : null,
        restaurant: `${checkIn.restaurant && checkIn.restaurant.name ? checkIn.restaurant.name : null}, ${checkIn.restaurant && checkIn.restaurant.address ? checkIn.restaurant.address : ''}`,
        hasUpcomingPlan: checkIn.user && checkIn.user ? checkIn.user.hasUpcomingPlan : null,
        planStatus: checkIn.user && checkIn.user && checkIn.user.planStatus ? checkIn.user.planStatus : null,
        reverseTransactionData: checkIn.transaction && checkIn.transaction.reverseTransactionData ? checkIn.transaction.reverseTransactionData : null
      }
    ))
  }

  function refresh() {
    setTableLoading(true)
    client.query({
      query: GET_CHECKINS,
      variables: { first: 10, filters: { restaurant: { id: restaurantId } }, orderByFilter },
      fetchPolicy: 'network-only'
    }).then(result => {
      checkInData = result
      client.query({
        query: CHECKINS_CONNECTIONS,
        variables: { filters, orderByFilter },
        fetchPolicy: 'network-only'
      }).then(result => checkInDataCount = result)
    }).catch(e => {
      console.log(e)
    }).finally(() => {
      setCurrentPageNumber(1)
      setTableLoading(false)
    })
  }

  function handlePagination(pageNumber) {
    if (totalCount > checkInData.checkIns.length) {
      setCurrentPageNumber(pageNumber)
      setTableLoading(true)
      fetchMore({
        variables: {
          skip: (pageNumber - 1) * 10,
          first: 10
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          const { checkIns } = fetchMoreResult
          setTableLoading(false)
          return checkIns.length ? { checkIns: [...checkIns] } : prevResult
        }
      })
    }
  }

  const paginationProps = {
    position: 'bottom', total: totalCount, onChange: (e) => handlePagination(e), current: currentPageNumber
  }

  return (
    <Row gutter={24} type="flex" className="news-chat-wrapper">
      <Meta title="Check Ins" description="" />
      <Col span={24}>
        <div className="title-wrapper">
          <Title level={2}></Title>
          <div>
            <Button type="primary" size='large' onClick={() => refresh()}>Refresh</Button>
          </div>
        </div>
        <Table
          scroll={{ x: true }}
          bordered
          loading={networkStatus === 1 || tableLoading || checkInLoad}
          dataSource={postTableData}
          columns={columns}
          pagination={false}
          onChange={handleChange}
        />
        <Pagination onChange={handlePagination} current={currentPageNumber} total={totalCount} {...paginationProps} />
        <ReverseModal
          saveFormRef={saveFormRef}
          shoModal={showModal}
          isSubmit={isSubmit}
          handleCancel={handleCancel}
          handleCreate={handleCreate}
          editableData={editableData}
        />
        <ReverseDetailsModal
          visible={showReverseDetailsModal}
          onCancel={handleCancel}
          editableData={editableData}
        />

      </Col>
    </Row>
  )
}

export default withRouter(RestaurantCheckIn);
